<template>
  <el-dialog
    v-drag:common
    title="导入敏感因素"
    :visible="visible"
    :show-close="false"
    width="400px"
  >
    <el-form
      :model="formData"
      class="demo-form-inline"
      ref="exclusiveImport"
      :rules="rules"
    >
      <el-form-item label="敏感因素文件" label-width="110px" prop='fileId'>
        <el-upload
          ref="uploadFile"
          :limit="1"
          :action="action"
          :data="{ file: 'file', apiKey: getToken(), type: 9 }"

          :on-success="
            (response, file, fileList) =>
              onFileUploadSuccess(response, file, fileList, 'fileId')
          "
          :file-list="fileListMap.fileIdList"
          :on-remove="
            (file, fileList) => removeFile(file, fileList, 'fileId')
          "
          :on-change="
            (file, fileList) => handleChange(file, fileList, 'fileId')
          "
          accept=".kmz,.zip"
        >
          <ct-button type="primary" size="small">点击上传</ct-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="敏感因素类别" prop="exclusiveTypeId" label-width="110px">
        <el-select v-model="formData.exclusiveTypeId" placeholder="请选择类别" style="width:100%">
          <el-option v-for="item in exclusveTypeList" :label="item.name" :value="item.dataId"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getToken } from '@/utils';
import { uploadExclusiveFile,getExclusiveTypeList } from '../service';
import to from 'await-to-js';
export default {
  props: ['visible'],
  data() {
    return {
      exclusveTypeList: [],

      formData: {
        projectId: null,
        fileId: null,
        exclusiveTypeId: null
      },
      action: `${process.env.VUE_APP_API_HOST_WINDDATA}/windfarm/station/uploadFile`,
      rules: {
        fileId: [
          { required: true, message: '请上传敏感因素!', trigger: 'change' },
        ],
        exclusiveTypeId: [
          { required: true, message: '请选择类别', trigger: 'change' }
        ],
      },
      fileIdsMap: {},
      fileListMap: {
        fileIdList: [],
      },
    };
  },
  mounted(){

  },
  onShow(){
  },
  computed: {},
  watch: {
    'visible':  function (val) {
      if(val === true){
        val;
        this.getExclusiveTypeList();
      }else{
        this.$refs.exclusiveImport.resetFields();
        this.$refs.uploadFile.clearFiles();
      }
    }
  },
  methods: {
    getToken,
    close() {
      this.$refs.uploadFile.clearFiles();
      this.$emit('close');
    },
    getExclusiveTypeList(){
      getExclusiveTypeList().then(res => {
        this.exclusveTypeList = res.data.list;
      });
    },
    submit() {
      this.$refs.exclusiveImport.validate(async (valid) => {
        if (valid) {
          const [err] = await to(
            uploadExclusiveFile({
              projectId: this.$route.query.projectId,
              exclusiveTypeId: this.formData.exclusiveTypeId,
              ...this.fileIdsMap,
            })
          );

          if (!err) {
            // this.close();
            this.$emit('uploadConfirm');
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    async onFileUploadSuccess(response, file, fileList, key) {
      if (response.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success',
        });
        const { files } = response.data;
        this.formData[key] = files;
        this.fileIdsMap[key] = files.fileId;
        console.log('this.fileIdsMap[key]',this.fileIdsMap[key]);
        this.$refs.exclusiveImport.validate();
        return;
      }

      setTimeout(() => {
        this.fileIdsMap[key] = '';
        this.formData[key] = '';
        this.fileListMap[key + 'List'] = [];

        this.$message({
          message: response?.message || '上传文件失败',
          type: 'error',
        });
      }, 50);
    },

    removeFile(file, fileList, key) {
      this.fileIdsMap[key] = '';
      this.fileListMap[key + 'List'] = fileList;
      this.formData[key] = fileList;
    },
    handleChange(file, fileList, key) {
      this.fileListMap[key + 'List'] = fileList.slice(-5);//取最后五个
      //this.fileListMap[key + 'List'] = [file];
    },
    onExceed() {
      this.$message.error('只允许上传一个文件， 请先删除再上传');
    }
  },
};
</script>

